import { useEffect, useReducer } from 'react';
import { pluralize } from '../ProgressBarHelpers';

const reducer = (state, action) => {
  switch (action.type) {
    case 'go-to-100':
      return 100;
    case 'return-to-0':
      return 0;
    case 'reset':
      return action.payload;
    default:
      return state;
  }
};

const timeLeftComplete = remainingInfo => {
  if (remainingInfo.weeks > 0) {
    return `${remainingInfo.weeks} ${pluralize('week', remainingInfo.weeks)}`;
  } else if (remainingInfo.days > 0) {
    return `${remainingInfo.days} ${pluralize('day', remainingInfo.days)}`;
  }
  return `${remainingInfo.hours} ${pluralize('hour', remainingInfo.hours)}`;
};

const useRaffleProgress = ({ percentage, remainingInfo }) => {
  const [state, dispatch] = useReducer(reducer, percentage);

  useEffect(() => {
    let timeout;

    if (percentage === 0 && state === 50) {
      dispatch({ type: 'go-to-100' });
    } else if (percentage === 0 && state === 100) {
      timeout = setTimeout(() => {
        dispatch({ type: 'return-to-0' });
      }, 350);
    } else {
      dispatch({ type: 'reset', payload: percentage });
    }

    return () => clearTimeout(timeout);
  }, [percentage, state]);

  return { state, timeLeft: timeLeftComplete(remainingInfo) };
};

export default useRaffleProgress;
